import { Component, OnInit} from "@angular/core";
import { MatDialog} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { MsalBroadcastService } from "@azure/msal-angular";
import { EventMessage, EventType } from "@azure/msal-browser";
import { environment } from "@env/environment";
import { SettingsService } from "@shared/services/settings.service";
import { SharedService } from "@shared/services/shared.service";
import { AuthService } from "@shared/auth/auth.service";
import { UserService } from "app/services/user/user.service";
import { filter } from "rxjs/operators";

interface IWelcomeDialogModel {
  route: string;
  icon: string;
  title: string;
  description: string;
  backgroundColor: string;
}

@Component({
  selector: "app-welcome",
  templateUrl: "./welcome.component.html",
  styleUrls: ["./welcome.component.scss"]
})

export class WelcomeComponent implements OnInit {
  private defaultRoute: string = 'dashboard';
  private route: string = 'route';
  private redirectFromProfile: string = 'redirectFromProfile';
  loggingIn: boolean = false;
  private authType: string = environment.auth.defaultAuth;

  constructor(
    public settings: SettingsService,
    private router: Router,
    private userService: UserService,
    public sharedService: SharedService,
    private authService: AuthService,
    public dialog: MatDialog,
    private msalBroadcastService: MsalBroadcastService) { }

  ngOnInit(): void {
    if(this.authService.isAuthenticated()){
      this.loggingIn = true;
      this.userService.getUserInfo().subscribe({
        next: response => this.sharedService.userProfile = response,
        error: error => this.sharedService.consoleLog(error),
        complete: () => {
          this.sharedService.toggleTheme();
          if(this.sharedService.userProfile.currentPage != null && this.sharedService.userProfile.currentPage.length > 0) {
            this.router.navigateByUrl(this.sharedService.userProfile.currentPage);
          }
          else {
            this.router.navigateByUrl(this.defaultRoute);
          }
          this.loggingIn = false;
        }
    });
    }
    else{
      this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe(() => {
        this.loggingIn = true;
        this.userService.getUserInfo().subscribe({
          next: response => this.sharedService.userProfile = response,
          error: error => this.sharedService.consoleLog(error),
          complete: () =>{
            this.sharedService.toggleTheme();
            this.loggingIn = false;
            let redirectFromProfile = window.localStorage.getItem(this.redirectFromProfile);
            if(redirectFromProfile != null){
              window.localStorage.removeItem(this.redirectFromProfile);
              if(this.sharedService.userProfile.currentPage != null && this.sharedService.userProfile.currentPage.length > 0) {
                this.router.navigateByUrl(this.sharedService.userProfile.currentPage);
              }
              else {
                this.router.navigateByUrl(this.defaultRoute);
              }
            }
            else{
              let route = window.localStorage.getItem(this.route);
              if(route != null){
                window.localStorage.removeItem(this.route);
                this.router.navigateByUrl(route);
              }
              else{
                this.router.navigateByUrl(this.defaultRoute);
              }
            }
          }
        })
      });
    }
  }

  isB2C() : boolean {
    return this.authService.isB2C();
  }

  isAAD() : boolean {
    return this.authService.isAAD();
  }

  login(): void{
    window.localStorage.setItem(this.redirectFromProfile, 'true');
    this.authService.login();
  }


  loginRedirect(redirect: string): void {
    if (redirect == 'cancel' || redirect == null || redirect == '') {
      return;
    }
    window.localStorage.setItem(this.route, redirect);
    this.authService.login();
  }

}


